import * as types from './actionType.js';
import asyncActionCreator from '../utils/asyncActionCreator';
import API from '../API/api'

const getUserInfoAsyncRequest = (data) => ({
    type: types.GET_USER_REQUEST,
    payload: data
});

const getUserInfoAsyncSuccess = (data,product) => ({
    type: types.GET_USER_SUCCESS,
    payload: {data,product},
});

const getUserInfoAsyncFailure = (error) => ({
    type: types.GET_USER_FAILURE,
    payload: error
});

export const changePath = (path) => ({
    type: types.PATH_CHANGE,
    payload:path
})

export const getUserInfo = (callback,data) => asyncActionCreator(
    API.GET_USER_INFO,
    getUserInfoAsyncRequest,
    getUserInfoAsyncSuccess,
    getUserInfoAsyncFailure,
    'POST',
    data,
    callback
);
export const setLiveToken = (data) => ({
    type: types.SET_LIVE_TOKEN,
    payload: data,
});


// WEBPACK FOOTER //
// ./src/entry_app/action.js